var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoteDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 887"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 257",
    cx: 15,
    cy: 15,
    r: 7,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.0109 20.9878C15.9346 20.9878 13.859 20.9884 11.7827 20.9872C11.3569 20.9872 11.0365 20.7132 11.0036 20.3313C10.9629 19.8572 11.2713 19.5075 11.7426 19.5026C12.2804 19.4978 12.8182 19.502 13.3553 19.5008C13.6158 19.5008 13.6146 19.4996 13.5009 19.2529C13.0092 18.1823 12.5187 17.1112 12.0259 16.0407C11.9684 15.9158 11.9241 15.7873 11.9151 15.6503C11.9079 15.5418 11.9498 15.4709 12.0744 15.5006C12.8715 15.6891 13.6811 15.5715 14.4848 15.6C14.8279 15.6121 15.1717 15.6072 15.5154 15.5988C16.297 15.5782 16.8922 14.9053 16.8539 14.1106C16.8126 13.2504 16.4311 12.5975 15.7232 12.1326C15.6753 12.1011 15.5963 12.0835 15.6089 12.0101C15.625 11.9156 15.7203 11.8962 15.7927 11.8616C16.7461 11.4094 17.7007 10.959 18.6547 10.508C18.9391 10.3734 19.2218 10.2364 19.5075 10.1055C20.0009 9.87999 20.3866 10.0164 20.6148 10.511C21.3945 12.1974 22.1688 13.8863 22.945 15.5745C23.5947 16.9881 24.2265 18.4109 24.9002 19.8124C25.2069 20.4501 24.7643 21.009 24.1493 20.9999C22.1035 20.9684 20.0572 20.9878 18.0109 20.9878Z",
    fill: "url(#paint0_linear_18520_180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.00388 10.094C9.00388 9.26211 9.00874 8.43082 9.00065 7.59888C8.99849 7.38642 9.03301 7.28339 9.23743 7.27379C9.855 7.24499 10.472 7.19187 11.0891 7.14772C11.7325 7.10164 12.3765 7.0562 13.02 7.00885C13.8868 6.94549 14.6667 7.21939 15.3042 7.92718C15.8943 8.58248 16.3964 9.3389 16.9417 10.046C17.0447 10.1798 17.0021 10.2438 16.8846 10.3078C16.4687 10.5343 16.0593 10.7769 15.6397 10.9932C15.2756 11.1813 14.9498 11.4245 14.7007 11.7969C14.6332 11.8974 14.5475 11.9153 14.4499 11.9147C14.2212 11.9141 13.9925 11.9102 13.7638 11.9179C13.5119 11.9262 13.3496 12.1182 13.3517 12.3934C13.3533 12.6686 13.5151 12.8503 13.7703 12.8631C14.1128 12.881 14.4563 12.8324 14.7977 12.8964C15.4105 13.0116 15.8592 13.5645 15.9266 14.2908C15.9633 14.6818 15.788 14.9724 15.4596 14.9756C14.6262 14.9845 13.7908 15.0389 12.9596 14.9487C12.2336 14.8693 11.6921 14.4188 11.3145 13.6822C11.0664 13.1972 10.6603 13.0109 10.2239 12.9405C9.90678 12.89 9.57885 12.9201 9.25631 12.9341C9.06591 12.9425 8.99687 12.8721 9.00011 12.6366C9.01036 11.7893 9.00388 10.9413 9.00388 10.0934V10.094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.00082 9.99414C5.00082 8.90504 4.99898 7.81524 5.00082 6.72614C5.00357 6.2358 5.28816 6.01259 5.92159 6.00409C6.31084 5.99984 6.701 5.997 7.08932 6.00551C7.69797 6.01897 7.99633 6.25139 7.99725 6.71905C8.00092 8.90646 8.00092 11.0939 7.99725 13.2813C7.99725 13.7801 7.71358 13.9955 7.07647 13.9984C6.66428 13.9998 6.25208 14.0012 5.83989 13.9984C5.26888 13.9934 5.00449 13.79 5.00357 13.3415C4.99898 12.2255 5.00265 11.1095 5.00173 9.99414H5.00082Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18520_180",
    x1: 18,
    y1: 10,
    x2: 18,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BBBE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoteDark);
export default __webpack_public_path__ + "static/media/vote_dark.eff65a311940a5f32f7a0017b8313777.svg";
export { ForwardRef as ReactComponent };